export enum ETemplates {
  Auth = 'AUTH',
  Blank = 'BLANK',
  Main = 'MAIN',
  Settings = 'SETTINGS',
  Editor = 'EDITOR',
}
